// src/pages/auth/ResetPassword.tsx

import React from 'react';
import { Formik, Form } from 'formik';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import styles from './../login/Login.module.css';
import { FormikTextField } from '../../components/form-components/common-components/text-field/FormikTextField';
import * as Yup from 'yup';
import { useStore } from '../../hooks/useStore';
import { Box } from '@mui/material';
import KaldenLogo from '../../assets/kalden-logo.png';

interface ResetFormValues {
  newPassword: string;
  confirmPassword: string;
}

// 1) Form validasyonu
const ResetPasswordSchema = Yup.object().shape({
  newPassword: Yup.string().min(8, 'Şifre en az 8 karakter olmalı').required('Yeni şifre zorunlu'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('newPassword')], 'Şifreler eşleşmiyor')
    .required('Yeni şifreyi tekrar giriniz'),
});

export const ResetPassword: React.FC = () => {
  const { authStore } = useStore();
  const navigate = useNavigate();

  // Query string içinden `email` ve `token` parametrelerini alıyoruz
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || '';
  const token = searchParams.get('token') || '';

  const handleSubmit = async (values: ResetFormValues) => {
    try {
      if (!email || !token) {
        toast.error('Geçersiz şifre sıfırlama isteği.');
        return;
      }

      const payload = {
        email,
        token,
        newPassword: values.newPassword,
      };

      const response: any = await authStore.resetPassword(payload);
      if (response.error) {
        toast.error(response.message || 'Şifre sıfırlama başarısız oldu');
        return;
      }

      toast.success(response.message || 'Şifreniz başarıyla sıfırlandı.');
      navigate('/login'); // Başarılı olunca girişe yönlendirebilirsiniz
    } catch (error) {
      console.error(error);
      toast.error('Şifre sıfırlama işlemi sırasında bir hata oluştu');
    }
  };

  return (
    <div className={styles.container}>
      <img src={KaldenLogo} alt="Kalden Logo" className={styles.logo} />
      <div className={styles.formWrapper}>
        <h1 className={styles.title}>Yeni Şifre Belirle</h1>
        <Formik
          initialValues={{ newPassword: '', confirmPassword: '' }}
          validationSchema={ResetPasswordSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form className={styles.form}>
              <FormikTextField
                name="newPassword"
                label="Yeni Şifre"
                type="password"
                placeholder="Yeni şifrenizi giriniz"
              />
              <FormikTextField
                name="confirmPassword"
                label="Yeni Şifre (Tekrar)"
                type="password"
                placeholder="Yeni şifrenizi tekrar giriniz"
              />

              <Box sx={{ mb: 2 }} />

              <button type="submit" className={styles.submitButton} disabled={isSubmitting}>
                {isSubmitting ? 'Gönderiliyor...' : 'Şifreyi Güncelle'}
              </button>

              <div className={styles.registerLink}>
                <Link to="/login">Giriş Sayfasına Dön</Link>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};
